import { ajaxService, loadState, urlService } from "../services";
import { loadResource, Response } from "../utility";

const removeDependency = () => { ajaxService.removeDependency() }

export async function getModules(refresh = false) {
    removeDependency()
    if (refresh) {
        return await loadResource(urlService.modules, 'modules');
    } else {
        let modules = await loadState('modules');

        if (modules == null) {
            return await loadResource(urlService.modules, 'modules');
        } else {
            return Response(modules);
        }
    }
}

export async function getModule(id) {
    removeDependency()
    return ajaxService.get(urlService.modules + '/' + id).then(response => {
        return Response(response.data);
    })
}

export async function saveModule(data) {
    removeDependency()
    return ajaxService.post(urlService.modules, data).then(response => {
        return Response(response.data);
    })
}

export async function updateModule(id, data) {
    removeDependency()
    return ajaxService.put(urlService.modules + '/' + id, data).then(response => {
        return Response(response.data);
    })
}

export async function deleteModule(id) {
    removeDependency()
    return ajaxService.delete(urlService.modules + '/' + id).then(response => {
        return Response(response.data);
    })
}
